export const FeeCalculationType = {
  AUTOMATED: 'Automated',
  CUSTOM: 'Custom',
};

export const FeeProvidersTreeItemType = {
  FEE_PROVIDER_CATEGORY: 'feeProviderCategory',
  FEE_PROVIDER: 'feeProvider',
};

export const FeeCureType = {
  UNLIMITED_TOLERANCE: 'UnlimitedTolerance',
  ZERO_TOLERANCE: 'ZeroTolerance',
  TEN_PERCENT_TOLERANCE: 'TenPercentTolerance',
};

export const cureTypeOptions = [
  { name: 'Unlimited Tolerance', value: FeeCureType.UNLIMITED_TOLERANCE },
  { name: 'Zero Tolerance', value: FeeCureType.ZERO_TOLERANCE },
  { name: '10% Tolerance', value: FeeCureType.TEN_PERCENT_TOLERANCE },
];

export const FeeRecordingType = {
  DEED: 'Deed',
  MORTGAGE: 'Mortgage',
  POA: 'POA',
  NAME_AFFIDAVIT: 'NameAffidavit',
  MARRIAGE_CERTIFICATE: 'MarriageCertificate',
  DEATH_CERTIFICATE: 'DeathCertificate',
  ADDRESS_AFFIDAVIT: 'AddressAffidavit',
  LIEN_RELEASE: 'LienRelease',
  SUBORDINATION: 'Subordination',
  SB2: 'SB2',
  CONSERVATION: 'Conservation',
  QC_DEED: 'QCDeed',
  DEED_RECORDATION_TAX: 'DeedRecordationTax',
  MORTGAGE_RECORDATION_TAX: 'MortgageRecordationTax',
  MD_RECORDATION_TAX: 'MDRecordationTax',
};

export const recordingTypeOptions = [
  { name: 'Deed', value: FeeRecordingType.DEED },
  { name: 'Mortgage', value: FeeRecordingType.MORTGAGE },
];

export const DISCOUNT_POINTS_FEE = 'DISCOUNT POINTS';

export const HARDCODED_FEES = {
  APPRAISAL_FEE: 'APPRAISAL FEE',
  ORIGINATION: 'ORIGINATION',
};

// Mirrors the Lender.Optimus.LoanApplications.Fees.FeeSource enum (serialized by name).
// A loan fee sourced from AppraisalSurcharge is materialized server-side from an
// appraisal surcharge snapshot and is folded into the base Appraisal Fee row (STP-242).
export const FeeSource = {
  APPRAISAL_SURCHARGE: 'AppraisalSurcharge',
};

export const FeeCureTxCoType = {
  INCLUDED: 'Included',
  EXCLUDED: 'Excluded',
};

export const FEE_TYPE_OVERRIDABLE_FIELDS = [
  'isEnabled',
  'customValue',
  'allowAmountEditing',
  'feeAmountExpression',
  'feeAmountUserFriendlyExpression',
  'expression',
  'userFriendlyExpression',
  'countTowardsApr',
  'feeProviderCategoryIds',
];
